/// <reference path='../types/global.d.ts' />
import { KJUR, KEYUTIL } from 'jsrsasign';
import { setCookie, getCookie, deleteCookie } from '../utils/cookies';
import { sendEvent } from '../utils/events';
import { getUrlParameter } from '../utils/url';
import uuidv4 from 'uuid/v4';

import pkceChallenge from 'pkce-challenge';

const wKJUR = window.KJUR || KJUR;
const wKEYUTIL = window.KEYUTIL || KEYUTIL;
export class AuthService {
  baseUrl: string;
  clientId: string;

  constructor({ baseUrl, clientId }: { baseUrl: string; clientId: string }) {
    this.baseUrl = baseUrl;
    this.clientId = clientId;
  }

  signIn(
    promptForLogin: boolean = true,
    additionalScopes?: string,
    sessionToken?: string
  ) {
    const pkce = pkceChallenge();
    setCookie('pkce-code-verifier', pkce.code_verifier, 1);

    console.log(additionalScopes);

    var state = uuidv4();
    window.sessionStorage.setItem('stt', state);
    window.location.href =
      `${this.baseUrl}/authorize` +
      `?client_id=${this.clientId}` +
      '&response_type=code' +
      `&scope=openid profile${additionalScopes ? ' ' + additionalScopes : ''}` +
      `&state=${state}` +
      `&redirect_uri=${window.location.origin}/auth/callback` +
      `&code_challenge=${pkce.code_challenge}` +
      `&code_challenge_method=S256` +
      (promptForLogin ? `` : `&prompt=none`) +
      (sessionToken ? `&sessionToken=${sessionToken}` : ``);
  }

  doLogout() {
    const idToken = getCookie('enginuity-sp-id-token');
    window.location.href = `${this.baseUrl}/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${window.location.origin}/auth/signout`;
  }

  async signOut() {
    deleteCookie('enginuity-sp-id-token');
    deleteCookie('enginuity-sp-token');
    deleteCookie('enginuity-sp-token-key');
    setTimeout(() => {
      sendEvent('sp-auth-changed');
    }, 100);
  }

  async requestToken() {
    const pkceCodeVerifier = getCookie('pkce-code-verifier');
    const authCode = getUrlParameter('code') || '/';
    const url = `${this.baseUrl}/token`;
    const data = {
      grant_type: 'authorization_code',
      code: authCode,
      redirect_uri: `${window.location.origin}/auth/callback`,
      client_id: this.clientId,
      code_verifier: pkceCodeVerifier
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    return response.json();
  }

  getValidKey(token: string, keys: any) {
    return keys.find((key: any) => {
      return wKJUR.jws.JWS.verifyJWT(token, wKEYUTIL.getKey(key), {
        alg: ['RS256'],
        gracePeriod: 60 * 2,
      });
    });
  }

  async setTokens(token: string, idToken: string) {
    if (!token) {
      throw new Error('No token returned.');
    }

    if (!idToken) {
      throw new Error('No ID token returned.');
    }
    
    const keys = await this.getPublicKeys();
    const validKey = this.getValidKey(token, keys);

    if (!validKey) {
      console.log('----');
      console.log(`Error token: ${token}`)
      console.log(`Error keys: ${JSON.stringify(keys)}`)
      console.log('----');
      throw new Error(`No valid tokens found.`);
    }

    setCookie('enginuity-sp-id-token', idToken, 1);
    setCookie('enginuity-sp-token', token, 1);
    setCookie('enginuity-sp-token-key', JSON.stringify(validKey), 1);

    sendEvent('sp-auth-changed');
  }

  async getPublicKeys() {
    const url = `${this.baseUrl}/keys?client_id=${this.clientId}`;
    const response = await fetch(url, { method: 'GET', cache: 'no-store' });
    const keyData = await response.json();

    // todo: check for a specific type of key from a potential set
    return keyData.keys;
  }
}
